
























































import { Component, Vue } from 'vue-property-decorator';
import { InviteDTO, SelectOption, Response } from '@/types';
import { Getter } from 'vuex-class';
import { UtilService, userSvc } from '@/services';
import { Notification } from 'element-ui';

@Component({
  name: 'invite'
})
export default class Invite extends Vue {
  private isLoading: boolean = false;
  private invite: InviteDTO = {
    email: '',
    name: '',
    roles: []
  };

  @Getter
  getRoleOptions!: SelectOption[];

  async onSubmit(e: Event) {
    e.preventDefault();
    this.isLoading = true;
    if (UtilService.validateEmail(this.invite.email)) {
      const resp: Response = await userSvc.invite(this.invite);
      Notification.success(resp.message);
      // reset
      this.invite.email = '';
      this.invite.name = '';
      this.invite.roles = [];
    } else {
      Notification.error('Invalid email');
    }
    this.isLoading = false;
  }
}
